import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BrandUpdateVO } from "@youm-front/brand/domain";

export class RoomBrandUpdateVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandUpdateVO.validationSchema(),
    BrandUpdateVO
  );

  constructor(readonly value: RoomBrandUpdate) {
    JsonSchemaValidator.assert(RoomBrandUpdateVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandUpdateVO"],
      properties: {
        roomId,
        brandUpdateVO: {
          instanceof: BrandUpdateVO.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandUpdate {
  roomId: RoomId;
  brandUpdateVO: BrandUpdateVO;
}
